var icon = require('vue-svgicon');
// console.log('');
icon.register({
  'wizhat': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: `<path pid="0" d="M18.847 22L14.721 5.188c-.203-1.34-1.586-2.145-2.973-2.152L5 3l3.288 1.892v1l1.5 1-3.292 15.116c3.836 0 5.973-.008 12.351-.008zm-2.65-3.84l-.75.7.25 1.05-1-.45-1 .45.25-1.05-.75-.7 1.052-.2.449-1.05.449 1.05zm-3.29-9.36a1.986 1.986 0 0 0-.196.848c0 1.101.894 1.996 1.996 1.996.031 0 .063-.008.094-.008a1.997 1.997 0 0 1-1.805 1.148A1.997 1.997 0 0 1 11 10.788c0-1.07.848-1.937 1.906-1.988zm-1.73 6.197l.449-1.05.45 1.05 1.05.2-.75.698.25 1.051-1-.45-1 .45.25-1.05-.75-.7z"/>`
  }
});



// WEBPACK FOOTER //
// ./src/icons/wizhat.js